import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import LazyBox from "../lazy/LazyBox";





const ClassPackWalletCard = ({
    thumbnail, type, classesLeft, onFindEvent, onPurchase, onBook, host, notOwned, price, duration
} : {
    thumbnail:string;
    host?:{
        name:string;
        id:string;
    };
    type:string;
    classesLeft:number;
    onFindEvent?:()=>void;
    onPurchase:()=>void;
    onBook?:()=>void;

    notOwned?:boolean;
    price?:number;
    duration?:number;
}) => {
    const navigate = useNavigate()

    return <Box
        bg='white'
        flex="0 0 auto"
        borderRadius='10px'
        boxShadow='0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14'
        
        w='100%' maxW='400px'
        borderWidth='1px'
        borderColor='#DCE2EA' overflow='hidden'
    >
        <LazyBox h='151px' 
            height={200}
            width={400}
            src={thumbnail}
            //bgImage={thumbnail}
            bgRepeat='no-repeat'
            bgPos='center'
            bgSize='cover'
            bgColor='#dce1ea'
        />
        <Box p='20px'>
            <Text variant='title' fontSize='lg'>{type}</Text>

            <Flex justifyContent='space-between'>
                {host &&
                    <Text variant='title' fontSize='12px'>Host: <span 
                    onClick={() => navigate(`/user/profile?id=${host.id}`)}
                    style={{
                        color:'#7E8B9A', cursor:'pointer'
                    }}>{host.name}</span></Text>
                }
                <Text variant='title' fontSize='12px'><span style={{
                    color:classesLeft >= 2 ? '#06C270' : '#FF3B30'
                }}>{classesLeft}</span> {!notOwned ? `class${classesLeft === 1 ? '' : 'es'} left${duration ? ` (${duration} minutes per class)` : ''}` : duration ? ` ${duration}-minute classes` : ' classes'}</Text>

            </Flex>
            <Flex gap='12px' mt='10px' maxW='300px'>
                <Button variant='light' w='100%'
                    onClick={() => onFindEvent ? onFindEvent() : onBook ? onBook() : undefined}
                >
                    {onFindEvent ? 'Find Event' : 'Book Slot'}
                </Button>
                <Button variant='heavy' w='100%'
                    onClick={() => onPurchase()}
                >
                    {notOwned ? `Buy for $${price}` : "Buy More"}
                </Button>
            </Flex>
        </Box>

        
    </Box>

}


export default ClassPackWalletCard;